import { Navigate } from 'react-router-dom'
import { getClientPublicEntryPath } from '@/config/tenant'
import { useUser } from '@/contexts/UserContext'
import { useClienteSessionValidation } from '@/hooks/useClienteSessionValidation'
import { clearSessionForRole, setAuthNotice } from '@/utils/authFlow'
import { isAdmin } from '@/utils/adminAuth'

interface RequireClientAuthProps {
  children: React.ReactNode
}

/**
 * Redireciona para o portal se não houver sessão de cliente válida (cookie + API).
 * Administradores com sessão ativa podem navegar na app para pré-visualizar conteúdo público.
 */
export function RequireClientAuth({ children }: RequireClientAuthProps) {
  const { user } = useUser()
  const gate = useClienteSessionValidation()

  if (isAdmin()) return <>{children}</>

  // Utilizador já conhecido em memória (ex.: acabou de fazer guest-checkout) — não expulsar
  if (user) return <>{children}</>

  if (gate === 'checking') {
    return null
  }

  if (gate === 'denied') {
    clearSessionForRole('cliente')
    setAuthNotice('cliente', 'A sua sessão terminou. Faça login para continuar.')
    return <Navigate to={getClientPublicEntryPath()} replace />
  }

  return <>{children}</>
}
